<mat-card>
  <mat-card-content>
    <mat-card-title> 
      Referente

  
      <button mat-raised-button
              color="primary" (click)="btnAggiungiModifica(-2)" style="float: right">
        Nuovo
      </button>
    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
   <p style="color: red">modifica, nuovo</p>
    <div fxLayout="row wrap">
      <div fxFlex.gt-sm="50%">
        <mat-form-field class="full-width">
          <input matInput
                 placeholder="Filtra"
                 [(ngModel)]="txtFiltra"
                 id="txtFiltra"
                 value=""
                 (keyup)='updateFilter($event)'>
        </mat-form-field>
      </div>
    </div>
    
    <ngx-datatable #grdReferente
                   [rows]="lstElenco"
                   [columnMode]="'flex'"
                   [headerHeight]="50"
                   [footerHeight]="50"
                   [limit]="30"
                   [rowHeight]="'auto'">
    
      <ngx-datatable-column name="" [flexGrow]="0.5">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="float:left">
            <button mat-icon-button mat-sm-button color="primary"
                    class="mr-1"
                    (click)="btnAggiungiModifica(row.idReferenteTipologia)"
                    matTooltip="Modifica">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
   
      <ngx-datatable-column name="Referente"
                            [flexGrow]="2"
                            [sortable]="true"
                            prop="ReferenteTipologia">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.ReferenteTipologia }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Visibile"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Visibile">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Visibile === 1 ? 'Si' : 'No'}}
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>

  </mat-card-content>
</mat-card>


